import React from 'react';

const disabledTextColor = "var(--text-soft-color)";
const textColor = "var(--text-color)";
const mutedTextColor = "var(--text-muted-color)";

const ButtonInput = ({
  label,
  disabled,
  buttonName,
  buttonCallback = () => {},
  inputContainerStyle={},
  buttonStyle={},
  title,
  description,
}) => (
  <div
    className="input-container"
    style={inputContainerStyle}
  >
    {label && 
      <div
        className="input-label"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          color: disabled ? disabledTextColor : textColor,
          flex: "1"
        }}
      >
        <span>{label}</span>
      </div>
    }
    {description &&
      <div
        className="input-label"
        style={{
          color: mutedTextColor,
          fontStyle: "italic",
          margin: "5px 0px",
          marginBottom: "10px",
          marginTop: "-5px"
        }}
      >
        {description}
      </div>
    }
    <div
      style={{
        display: 'flex',
        flex: "1"
      }}
    >
      <div
        className={"button " + (disabled ? "secondary" : "")}
        style={{
          color: disabled ? disabledTextColor : undefined,
          cursor: disabled ? "default" : "pointer",
          opacity: disabled ? 0.65 : 1,
          ...buttonStyle
        }}
        onClick={() => {
          if (!disabled) {
            buttonCallback()
          }
        }}
        title={title}
      >
        {buttonName}
      </div>
    </div>
  </div>
);

export default ButtonInput;
